import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import SmartInput from './Components/SmartInput.js';

import TopAppBar from './Components/TopAppBar.js';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Config from './Config.json';
import {Link} from "react-router-dom";

import axios from 'axios';

import React, { useState, useEffect } from 'react';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

//in real scenarios, lessonData is made in an axios get request.
//backend determines content of lesson based on profile of user.
var defaultLessonData = [
  {
    "png":"[question theme encoded in base64]",
    "answers":["Loading..."],
    "sentFrags":["Loading..."],
    "choices": [["est", "es", "etre"], ["sur", "son", "si"]],
    "hint":"sur..."
  },
  {
    "png":"[question theme encoded in base64]",
    "answers":["J'aime", "au"],
    "sentFrags":["", "aller", "parc"],
    "choices": [["J'aime", "Tu aimes", "Elle aime"], ["au", "aux", "à"]],
    "hint": "ur a cunt"
  },
];

const breadcrumbs = [
    <Link underline="hover" to="/" key="1" color="white" href="/">
      Vocab App
    </Link>,
    <Typography key="3" color="white">
      Practice
    </Typography>
  ];

function FillInTheBlanksPage() {

  var wrongAnswersGiven = [];

  const [lessonData, setLessonData] = useState(defaultLessonData);


  //int for keeping track of which question it is on
  const [questionIndex, setQuestionIndex] = useState(0);
  //bool for enabling/disabling submit button
  const [canSubmit, setCanSubmit] = useState(false);
  //strings made: start out with [null] * no. of answers
  const [choicesMade, setChoicesMade] = useState(lessonData[0]["answers"].map(() => null));
  //sentence, but cut up into substrings, separated by answer slots
  const [sentFrags, setSentFrags] = useState(lessonData[0]["sentFrags"]);
  const [correct, setCorrect] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [open, setOpen] = useState(false);

  

    React.useEffect(() => {
      axios.get(Config.urlStub + "/lessonData").then((response) => {
        //lessonData = response.data;
        // console.log("lessonData is", response.data);
        setLessonData(response.data);
        setSentFrags(response.data[questionIndex]["sentFrags"]);
        setChoicesMade(response.data[questionIndex]["answers"].map(() => null));

      });
      //setSentFrags(lessonData[questionIndex]["sentFrags"]);
      // console.log("updating sentfrags", lessonData[questionIndex]["sentFrags"]);
    }, []);

  function renderQuestion() {
    sentFrags.join(" __" +  + "__ ");
    var result = "";
    //what if sentence starts with choicesMade first? Just use empty string at start of sentFrags.
    //what if sentence doesn't end with choicesMade? check if i >= choicesMade.length - 1
    //what if there are multiple ones next to each other? white space. 
    for (var i = 0; i < sentFrags.length; i++) {
      result += sentFrags[i];
      if (i < choicesMade.length) {
        if (choicesMade[i] != null) {
          //to add highlights to answers, return a Typography component instead.
          result += " " + choicesMade[i] + " ";
        } else {
          result += " __" + "__ ";
        }
      }
    }
    return result;
  }

  function nextQuestion() {
    var resetChoicesMade = [];
    for (var i = 0; i < lessonData[questionIndex]["answers"].length; i++) {
      resetChoicesMade.push(null);
    }
    setCorrect(false);
    setSubmitted(false);
    setChoicesMade(resetChoicesMade);
    setQuestionIndex(questionIndex + 1);
    setSentFrags(lessonData[questionIndex + 1]["sentFrags"]);
  }

  function answer() {
    setSubmitted(true);
    for (var i = 0; i < lessonData[questionIndex]["answers"].length; i++) {
      if (choicesMade[i] != lessonData[questionIndex]["answers"][i]) {
        // console.log(choicesMade[i], lessonData[questionIndex]["answers"][i]);
        //TODO: register wrong answer for submission to server later on
        //wrongAnswersGiven += []...

        //open wrong snackbar
        setOpen(true);
        return;
      }
    }
    //open right snackbar, next question.
    
    setCorrect(true);
    setOpen(true);
    //setCanSubmit(false);
  }

  function updateChoices(newChoice, index) {
    // console.log("updateChoices", newChoice, index);
    const newChoices = choicesMade.map((c, i) => {
      if (i === index) {
        //update value of chosen index
        return newChoice;
      } else {
        //do nothing
        return c;
      }
    });
    setChoicesMade(newChoices);
    //check if user can submit. if true, set chosen to true
    for (var i = 0; i < newChoices.length; i++) {
      if (newChoices[i] == null) {
        setCanSubmit(false);
        return;
      }
    }
    //canSubmit is true if choicesMade has no nulls
    setCanSubmit(true);
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <div className="App-header" style={{ padding: 30 }}>
      <TopAppBar breadcrumbs={breadcrumbs}/>
      <Box>
        <Stack spacing={2}>

          <Grid container  justifyContent="center">
            <Grid item alignItems="center" style={{ display: "flex" }} align="center">
              <Typography color="white">
                Fill in the blanks for this sentence
              </Typography>
            </Grid>
          </Grid>


          <Grid container  justifyContent="center">
            <Grid item alignItems="center" style={{ display: "flex" }} align="center">
              <Typography color="white" variant="contained">
                {renderQuestion()}
              </Typography>
            </Grid>
          </Grid>

          <Grid container justifyContent="center" sx={{ p: 2}} spacing={2}>
            {lessonData[questionIndex]["answers"].map((value, index) => {
              return (
                  <Grid item align="center">
                    <Card sx={{ minWidth: 250 }} >
                      <SmartInput index={index} updateChoices={updateChoices} options={lessonData[questionIndex]["choices"][index]} key={questionIndex} />
                    </Card>
                  </Grid>
                )
            })}
          </Grid>

          <Button onClick={() => answer()} disabled={canSubmit === false} >
            <KeyboardArrowRightIcon sx={{ fontSize: 70 }}/>
          </Button>

          {correct ? 
        <Snackbar open={true} onClose={handleClose} anchorOrigin={{horizontal: 'center', vertical: 'bottom'}}>
          <Alert severity="success" action={
                                            <Button color="inherit" size="small" onClick={() => nextQuestion()}>
                                              CONTINUE [ENTER]
                                            </Button>
                                          }>
            Correct!
          </Alert> 
        </Snackbar>
      : <div/> }

    
      {(!correct && submitted) ? 
        <Snackbar open={open} autoHideDuration={1000} onClose={handleClose} anchorOrigin={{horizontal: 'center', vertical: 'bottom'}}>
          <Alert severity="error">
            Wrong!
          </Alert> 
        </Snackbar>
      : <div/> }

        </Stack>
      </Box>
    </div>
  )
}

  export default FillInTheBlanksPage;
